import React, { useEffect, useState } from "react";
import { Dimensions, Image, StyleSheet, Text, View } from "react-native";
import MaterialTabs from "react-native-material-tabs";
import { RFValue } from "react-native-responsive-fontsize";
import PDFReader from "rn-pdf-reader-js";
import CustomHeader from "../../components/CustomHeader";
import CloseIcon from "../../components/icons/CloseIcon";
import CachedImage from "react-native-expo-cached-image";
import moment from "moment";
import { Button } from "react-native-elements";
import { navigate } from "../../routes/Global";

const { height, width } = Dimensions.get("window");

const ViewNotarizeDetails = ({ route }) => {
  const { item } = route?.params || {};
  const { firstName, lastName, image, address, createdAt, hasAlreadyLicense } = item || {};
  const { line1, state, city, zipCode } = address || {};
  let location = [line1, state, city, zipCode].filter((o) => Boolean(o)).join(", ");
  let source = image ? { uri: image } : require("../../assets/user.png");
  let name = `${firstName} ${lastName}`;
  return (
    <View style={styles.container}>
      <CustomHeader title="View Profile" leftIcon={<CloseIcon />} />
      <View style={styles.view}>
        <Image source={source} style={styles.image} resizeMode="contain" />
        <Text style={styles.name}>{name}</Text>
        <Text style={styles.location}>{location}</Text>
        <Text style={styles.createdAt}>{"Signed Up on " + moment.unix(createdAt).format("MM/DD/YYYY")}</Text>
        <Text style={styles.hasLicense}>
          {"Already own mobile license? "}
          <Text style={[styles.hasLicense, { color: hasAlreadyLicense ? "green" : "red", fontFamily: "avenir-h" }]}>
            {hasAlreadyLicense ? "YES" : "NO"}
          </Text>
        </Text>
        <Button
          title="View Documents"
          buttonStyle={styles.buttonStyle}
          titleStyle={styles.buttonTitle}
          onPress={() => navigate("viewnotarizedocuments", { item: item })}
        />
      </View>
    </View>
  );
};

export default ViewNotarizeDetails;

const styles = StyleSheet.create({
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    marginVertical: 10,
    paddingVertical: 10,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  hasLicense: { fontFamily: "avenir", fontSize: RFValue(12) },
  createdAt: { fontFamily: "avenir", fontSize: RFValue(12) },
  location: { fontFamily: "avenir", fontSize: RFValue(15) },
  name: { fontFamily: "avenir-h", fontSize: RFValue(20) },
  view: { flex: 1, justifyContent: "center", alignItems: "center" },
  image: {
    width: 100,
    height: 100,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: "#d3d3d3",
  },
  container: { flex: 1, backgroundColor: "#fff" },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
